import React, { useEffect, useState } from 'react';
import BreadCrumbs from '../common/BreadCrumbs';
import {
  CONTACT_FORM,
  CONTACT_INFO,
  SOCIAL_LINKS,
} from '../constants/ContactsConstant';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { validateEmail, validatePhoneNumber } from '../utils/common';
import { sendEmail } from '../utils/SendEmail';

const Contact = ({
  setTab,
}: {
  setTab: React.Dispatch<React.SetStateAction<string>>;
}) => {
  useEffect(() => {
    setTab('contact-us');
  }, [setTab]);

  const initialData = {
    name: '',
    companyName: '',
    email: '',
    phone: '',
    message: '',
  };
  const [formData, setFormData] = useState(initialData);
  const [loading, setLoading] = useState(false);

  // derive a clean variable name for EmailJS
  const nameMap: Record<string, string> = {
    Name: 'name',
    'Company / Organization': 'companyName',
    Email: 'email',
    Phone: 'phone',
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = () => {
    const { name, email, phone } = formData;
    let hasError = false;
    let errors = [];
    if (!name) {
      hasError = true;
      errors.push('Please enter your name');
    }
    if (!validateEmail(email)) {
      hasError = true;
      errors.push('Please enter your valid email');
    }
    if (!validatePhoneNumber(phone)) {
      hasError = true;
      errors.push('Please enter your phone number');
    }
    return { hasError, errors };
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const { hasError, errors } = validateForm();

    if (hasError) {
      for (const error of errors) {
        toast.error(error);
      }
      return;
    } else {
      sendEmail(
        formData,
        setFormData,
        initialData,
        'Message sent successfully!',
        3000,
        process.env.REACT_APP_EMAIL_JS_TEMPLATE_ID as string,
        setLoading,
      );
    }
  };

  return (
    <>
      <BreadCrumbs title='Contacts' description='For Any Query' />

      <div className='contact-page-wrap sec-mar'>
        <div className='container'>
          <div className='row g-lg-4 gy-5'>
            <div className='col-lg-6'>
              <div className='contact-content'>
                <span>CONTACT WITH US</span>
                <h2>LET’S WORK TOGETHER?</h2>
                <p>
                  I have worls-className, flexible support via live chat, email
                  and hone. I guarantee that you’ll be able to have any issue
                  resolved within 24 hours.
                </p>
                <div className='informations'>
                  {CONTACT_INFO.map(({ icon, type, content }) => (
                    <div key={type} className='single-info'>
                      <div className='icon'>
                        <i className={icon}></i>
                      </div>
                      <div className='info'>
                        {type === 'phone' ? (
                          <Link key={content} to={`tel:${content}`}>
                            {content}
                          </Link>
                        ) : type === 'email' ? (
                          <Link key={content} to={`mailto:${content}`}>
                            {content}
                          </Link>
                        ) : (
                          <p key={content}> {content} </p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
                <div className='follow-area'>
                  <h5 className='blog-widget-title'>Follow Us</h5>
                  <p className='para'>Follow us on Social Network</p>
                  <div className='blog-widget-body'>
                    <ul className='follow-list d-flex flex-row align-items-start gap-4'>
                      {SOCIAL_LINKS.map(({ icon, url }) => (
                        <li key={url}>
                          <Link
                            to={url}
                            target='_blank'
                            rel='noopener noreferrer'
                          >
                            <i className={icon}></i>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-lg-6'>
              <div className='contact-form-wrap'>
                <div className='form-tltle'>
                  <h5>Make a Free Consulting</h5>
                </div>
                <div className='contact-form'>
                  <form onSubmit={handleSubmit}>
                    <div className='row'>
                      {CONTACT_FORM.map((form, index) => (
                        <div key={index} className={form.className}>
                          <div className='form-inner'>
                            <label>
                              {form.label}
                              {(form.label === 'Name' ||
                                form.label === 'Email' ||
                                form.label === 'Phone') && (
                                <span style={{ color: 'red' }}>*</span>
                              )}
                            </label>
                            <input
                              type={form.type}
                              name={nameMap[form.label]}
                              value={
                                formData[
                                  nameMap[form.label] as keyof typeof formData
                                ]
                              }
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      ))}
                      <div className='col-lg-12 mb-20'>
                        <div className='form-inner'>
                          <label>Message</label>
                          <textarea
                            name='message'
                            value={formData.message}
                            onChange={handleInputChange}
                          ></textarea>
                        </div>
                      </div>
                      <div className='col-lg-12'>
                        <div className='form-inner'>
                          <button
                            className='primary-btn3'
                            type='submit'
                            disabled={loading}
                          >
                            {loading ? 'Sending...' : 'Submit'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='contact-map'>
        <iframe
          src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3771.9271955624486!2d73.03298239051402!3d19.022929532972153!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c334759927ef%3A0xa882bbe0714f9229!2sGopal%20Krishna!5e0!3m2!1sen!2sin!4v1770346432921!5m2!1sen!2sin'
          style={{ border: '0' }}
          allowFullScreen
          loading='lazy'
          referrerPolicy='no-referrer-when-downgrade'
        ></iframe>
      </div>
    </>
  );
};

export default Contact;
